import React from 'react';
import styled from 'styled-components';
import { AttachmentApi } from '../../api/attachment.api';
import { IMessageAttachment } from '../../interfaces/message.interface';
import { AttachmentThumbnailImg } from './AttachmentThumbnailImg';

const BaseStyledDiv = styled.div`
  display: flex;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `flex-wrap: wrap;
      margin-bottom: 16px;
      position: relative;
      &:last-child { margin-bottom: 0px; }`
      : `display: -ms-flexbox;
      flex-direction: column;
      padding: 0 0 8px;
      -ms-flex-direction: column;`}
`;

const StyledDiv = styled.div`
  float: left;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `cursor: pointer;
    flex-basis: 100%;
    width: 100%;`
      : ``}
`;

const StyledA = styled.a`
  font-size: 14px;
  line-height: 21px;
  position: relative;
  display: inline-block;
  color: ${(props: { disabled?: boolean }) =>
    props.disabled ? '#333333' : '#0783c2'};
  font-size: 14px;
  text-decoration: none !important;
  padding: 5px 40px 4px 15px;
  border: ${(props: { disabled?: boolean }) =>
    props.disabled ? 'solid 1px #333333' : 'solid 1px #00a0f0'};
  border-radius: 23px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: ${(props: { disabled?: boolean }) =>
    props.disabled ? 'default' : 'pointer'};

  &:hover {
    color: #333333;
  }

  &::after {
    position: absolute;
    top: 8px;
    right: 15px;
    content: '';
    display: block;
    width: 13px;
    height: 14px;
    background: ${(props: { disabled?: boolean }) =>
      props.disabled
        ? `url(/images/download_black.png) 0 0 no-repeat`
        : `url(/images/download.png) 0 0 no-repeat`};
    background-size: 100%;
  }
`;

const StyledSpan = styled.span`
  color: #bf0000;
`;

interface Props {
  isWide: boolean;
  attachments: Array<IMessageAttachment>;
  messageSentTimestamp: string;
  onClickAttachmentThumbnail: Function;
}

export const ChatMessageAttachments = (props: Props) => {
  const {
    isWide,
    attachments,
    messageSentTimestamp,
    onClickAttachmentThumbnail,
  } = props;
  if (!attachments || attachments.length === 0) {
    return null;
  }
  const isDisableLink = false;
  const isAttachmentDisabled = false;

  return (
    <BaseStyledDiv isWide={isWide}>
      {attachments.map(({ fileName, filePath, types }, index) => {
        const key = `${messageSentTimestamp}-attachment-${index}`;
        const hasThumbnail = types && types.length >= 2;
        const thumbnailPath = filePath.concat('-thumbnail');
        if (hasThumbnail && !isDisableLink) {
          return (
            <StyledDiv
              isWide={isWide}
              key={key}
              onClick={() => onClickAttachmentThumbnail(filePath, fileName)}
            >
              <AttachmentThumbnailImg
                fileId={thumbnailPath}
                fileName={fileName}
              />
            </StyledDiv>
          );
        } else {
          return (
            <StyledDiv isWide={isWide} key={key}>
              <StyledA
                onClick={async (event) => {
                  if (isAttachmentDisabled) {
                    event.preventDefault();
                  } else {
                    try {
                      await AttachmentApi.downloadAttachment(
                        filePath,
                        fileName,
                      );
                    } catch (e) {
                      console.error(e);
                      // do nothing, because this preview is in modal and hard to notify error message
                      // further, it merely happens
                    }
                  }
                }}
                disabled={isAttachmentDisabled}
                download={fileName}
                style={{
                  width: 'calc(100% - 57px)', //Padding distance
                }}
                target={'_self'}
              >
                {fileName}
              </StyledA>
            </StyledDiv>
          );
        }
      })}
      {isDisableLink ? (
        <StyledSpan>保存期間を超えたためダウンロードできません</StyledSpan>
      ) : null}
    </BaseStyledDiv>
  );
};
